import { render, staticRenderFns } from "./file.vue?vue&type=template&id=20f70284&"
import script from "./file.vue?vue&type=script&lang=ts&"
export * from "./file.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f70284')) {
      api.createRecord('20f70284', component.options)
    } else {
      api.reload('20f70284', component.options)
    }
    module.hot.accept("./file.vue?vue&type=template&id=20f70284&", function () {
      api.rerender('20f70284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/file.vue"
export default component.exports